import React, {useEffect} from 'react';
import CampaignSearch from "./search";
import {useLocation} from "react-router";
//import {Link} from 'react-router-dom';
import { CostsReport } from './costreport';
import { CreativeReport } from './creativereport';
import { useState } from 'react';
import {
  Campaign,
  CampaignsQueryDocument,
  useDeleteCampaignMutationMutation
} from '../../generated/graphql';
import {Button} from "@mui/material";
import {Download} from "@mui/icons-material";
import {useUserContext} from "../../contexts/user-context";
import {SideList} from "../../components/SideList";
import {useRecordModuleHistory} from "../../contexts/module-history-context";
import {FieldTableColumnProps} from "../../components/FieldTable/FieldTableTypes";
import { SundriesReport } from './SundriesReport';
import { useExchangeRatesContext } from '../../contexts/exchange-rates-context';
import { AreaBookingReport } from './AreaBookingReport';
import { DigitalBookingReport } from './DigitalBookingReport';

let ArrayIndex = 0;
const findConfirmationDate = (changes) => {
  let confirmedDate: string | null = null;
  for (let index = 0; index < changes.length; index++) {
    const change = changes[index];
    const parsedKeyFields = JSON.parse(change.key_fields);
    const updated_at = change?.updated_at;
    const formattedDate = updated_at
      ? new Intl.DateTimeFormat('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }).format(new Date(updated_at))
      : null;
    console.log(`${ArrayIndex} ARRAY TESTING ${index}:`, parsedKeyFields);

    if (parsedKeyFields.status === 'Confirmed') {
      console.log(`${ArrayIndex} ARRAY TESTING Changes ${index} has status Confirmed ON ${updated_at}`);
      confirmedDate = formattedDate;
    }
  }
  ArrayIndex++;

  return confirmedDate;
};
export const Campaigns = () => {
  const location = useLocation();
  const [doCostReport,setDoCostReport] = useState(false);
  const [doCreativeReport,setDoCreativeReport] = useState(false);
  const [doDigitalReport, setDoDigitalReport] = useState(false);
  const [doAreaBookingReport,setAreaBookingReport] = useState(false);
  const [doSundriesReport,setDoSundriesReport] = useState(false);
  const currencyContext = useExchangeRatesContext();
  const userContext = useUserContext();
  let arrayIndex = 0;
  const columns:FieldTableColumnProps<Campaign>[] = [
    {
      accessor:'job_reference',
      header: 'Job Ref',
      dataType:'link',
      width: 'minmax(4em, max-content)',
      options:{
        getLink:({field}) => {
          return {
            pathname: '/campaigns/' + field?.value,
            search: (location.search ? location.search : '')
          };
        }
/*      renderViewer:useCallback(({field})=> {
        return (<Link component={RouterLink} href={
          '/campaigns/' + field.value+(location.search ? '?'+location.search : '')
        }>{field.value}</Link>);
        return (<Link underline="always" component={RouterLink} to={}>{field.value}</Link>);
      },[location.search])*/
    }
    },{
      accessor:'status',
      header:'Status',
      width: 'minmax(4em, max-content)',
      dataType:'default'
    },{
      accessor:'name',
      header:'Job Name',
      className:'column-width-wide-plus',
      dataType:'default'
    },{
      accessor:'clientCompany.sales_company',
      header:'Client',
      className:'column-width-wide-plus',
      dataType:'default'
    },{
      accessor:'salesTeam.name',
      header:'Sales Team',
      dataType:'default'
    },{
      accessor:'sub_teams_scotland',
      header:'Sub Sales Team',
      dataType:'default'
    },{
      accessor:'ourContact.name',
      header:'Account Manager',
      dataType:'default'
    },{
      accessor:'total_price',
      header:'Total exc VAT',
      dataType:'currency',
      options: {
        currency: {
          accessor:'currency'
        }
      },
      readOnly:true
    },{
      accessor:'start_date',
      header:'Start Date',
      exportOnly: true,
      dataType:'date',
      readOnly:true,
    },{
      accessor:'completion_date',
      header:'Completion Date',
      dataType:'date',
      readOnly:true,
    },{
      accessor:'purchase_order',
      header:'Purchase Order',
      dataType:'default',
      exportOnly: true
    },{
      accessor:'invoice',
      header:'Invoice Number',
      dataType:'default',
      exportOnly: true
    },{
      accessor:'totals.experiential',
      header:'Experiential Total',
      exportOnly:true,
      dataType:'currency',
      options: {
        currency: {
          accessor:'currency'
        }
      },
      readOnly:true
    },{
      accessor:'totals.ambient',
      header:'Ambient Total',
      exportOnly:true,
      options: {
        currency: {
          accessor:'currency'
        }
      },
      dataType:'currency'
    },{
      accessor:'totals.creativestudio',
      header:'Creative Studio Total',
      exportOnly:true,

      options: {
        currency: {
          accessor:'currency'
        }
      },
      dataType:'currency'
    },{
      accessor:'totals.area_booking',
      header:'Area Booking Total',
      exportOnly:true,
      options: {
        currency: {
          accessor:'currency'
        }
      },
      dataType:'currency'
    },{
      accessor:'totals.panel_booking',
      header:'Panel Booking Total',
      dataType:'currency',
      options: {
        currency: {
          accessor:'currency'
        }
      },
      exportOnly:true
    },{
      accessor:'totals.digital_booking',
      header:'Digital Booking Total',
      dataType:'currency',
      options: {
        currency: {
          accessor:'currency'
        }
      },
      exportOnly:true
    },{
      accessor:'discount_final',
      header:'Goodwill Discount',
      exportOnly:true,
      dataType:'currency'
    },{
      accessor:'discountableTotal',
      header:'Discountable Total',
      exportOnly:true,
      dataType:'currency'
    },{
      accessor:'discount_percentage',
      header:'Discount Percentage %',
      exportOnly:true,
      dataType:'default'
    },{
      accessor:'totals.media_production',
      header:'Media Production Total',
      exportOnly:true,
      options: {
        currency: {
          accessor:'currency'
        }
      },
      dataType:'currency'
    },{
      accessor:'totals.sundry',
      header:'Other Revenue Total',
      exportOnly:true,
      dataType:'currency',
      options: {
        currency: {
          accessor:'currency'
        }
      }
    },{
      accessor:'posters_received',
      header:'Posters Received',
      dataType:'boolean',
      exportOnly: true
    },{
      accessor:'clientSubType.name',
      header: 'Campaign Client Type',
      dataType:'default'
    },{
      accessor:'regionalAmAllocation.name',
      header: 'Regional Allocation',
      dataType:'default',
    },{
      accessor:'currency.label',
      header:'Quote Currency',
      dataType:'default',
      exportOnly: true
    },
    {
      accessor: 'changes.key_fields',
      header: 'Confirmation Date',
      dataType:'default',
      exportOnly: true,
      options: {
        getValue: ({ row }) => {
          if (row && row.changes) {
            const confirmedDate = findConfirmationDate(row.changes);
            if (confirmedDate) {
              console.log('Confirmation date:', confirmedDate);
              return confirmedDate;
            }
          } else {
            console.log('Invalid or empty changes array');
          }
        },
      }
    }
  ];
  
  const searchForm = (args) => {
    return <CampaignSearch {...args} />;
  };
  const costReport = (args) => {
    setDoCostReport(true);
  }
  const creativeReport = (args) => {
    setDoCreativeReport(true);
  }
  const digitalReport = (args) => {
    setDoDigitalReport(true);
  }
  const areaBookingReport = (args) => {
    setAreaBookingReport(true);
  }
  const sundriesReport = (args) => {
    setDoSundriesReport(true);
  }
  const recordModuleHistory = useRecordModuleHistory();
  useEffect(() => {
    recordModuleHistory('campaigns');
  }, [recordModuleHistory, location]);
  const deleteMutation = useDeleteCampaignMutationMutation();
  return <SideList
      searchForm={searchForm}
      label="Campaign"
      skipScroll={true}
      className="campaigns"
      permission="campaigns"
      deleteMutation={deleteMutation}
      simpleDelete={true}
      getResults={(e)=>e.campaigns.data}
      query={CampaignsQueryDocument}
      columns={columns}
      baseUrl="/campaigns/"
      hasDelete={false}
      noEditorScroll={true}
      extraContent={(props)=>{ 
        if(doCostReport) return (<CostsReport done={()=>{setDoCostReport(false)}}/>);
        if(doCreativeReport) return (<CreativeReport done={()=>{setDoCreativeReport(false)}}/>);
        if(doDigitalReport) return (<DigitalBookingReport done={()=>{setDoDigitalReport(false)}}/>);
        if(doSundriesReport) return (<SundriesReport done={()=>{setDoSundriesReport(false)}}/>);
        if(doAreaBookingReport) return (<AreaBookingReport done={()=>{setAreaBookingReport(false)}}/>);
        return [];
      }}
      footer={userContext.hasPermission('reports.run')?<>
      <Button size="large" key="exportBtnAdv" onClick={costReport} startIcon={<Download/>}>Cost Report</Button>
      <Button size="large" key="exportBtnAdv" onClick={creativeReport} startIcon={<Download/>}>Creative Studio Report</Button>
      <Button size="large" key="exportBtnAdv" onClick={digitalReport} startIcon={<Download/>}>Digital Booking Report</Button>
      <Button size="large" key="exportBtnAdv" onClick={areaBookingReport} startIcon={<Download/>}>Area Booking Report</Button>
      <Button size="large" key="exportBtnAdv" onClick={sundriesReport} startIcon={<Download/>}>Other Report</Button>
      </>:[]}
    />;

//  return (<SideEditor
//  ><Outlet/></SideEditor>);
}

